export const DEFAULT_LANGUAGE_CODE = 'en'

const LEAD_FUNNEL_PATH = '/get-started'
export const LEAD_FUNNEL_URL_PRODUCTION = `https://getmoss.com${LEAD_FUNNEL_PATH}`
export const LEAD_FUNNEL_URL_STAGING = `https://webapp.internal.runmoss.run${LEAD_FUNNEL_PATH}`

const LEAD_FUNNEL_HOSTNAMES = new Set(['getmoss.com', 'www.getmoss.com', 'webapp.internal.runmoss.run'])

export const getLanguageCode = (locale: string | undefined): string => locale?.split('-')[0] ?? DEFAULT_LANGUAGE_CODE

export const isLeadFunnelUrl = (url: URL): boolean =>
  LEAD_FUNNEL_HOSTNAMES.has(url.hostname) && url.pathname.startsWith(LEAD_FUNNEL_PATH)
